require('./splitFields.scss');
// @ vendors
const React = require('react');
const { Component } = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const enhanceWithClickOutside = require('react-click-outside');

class SplitFields extends Component {
    constructor(props) {
        super(props);

        this.state = {
            focusClass: false,
            showCover: false,
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.isValid !== newProps.isValid && !newProps.isValid) {
            this.setState({
                showCover: false,
            });
        }
    }

    handleClick() {
        this.setInputFocus();
        this.setState({
            showCover: false,
        });
    }

    handleKeyPress(evt) {
        if (evt.key === 'Enter') {
            this.setInputFocus();

            this.setState({
                showCover: false,
            });
        }
    }

    handleOnBlur() {
        this.changeFocusClass();
    }

    handleOnFocus() {
        this.changeFocusClass();
    }

    changeFocusClass() {
        this.setState(prevState => ({
            focusClass: !prevState.focusClass,
        }));
    }

    setInputFocus() {
        const inputFocus = document.getElementById(this.props.inputFocus);

        if (inputFocus) {
            setTimeout(() => {
                inputFocus.focus();
            }, 100);
        }
    }

    render() {
        const { classCol, placeholder, style, text } = this.props;
        const { focusClass, showCover } = this.state;
        const coverClass = classNames('cover-field', { hidden: !showCover });
        const showChildrenClass = classNames({
            'hidden-children': showCover,
            split__children: !showCover,
        });
        const formInputClass = classNames('form__input', { row: classCol !== '', 'form__input--focus': focusClass });

        return (
            <div className="split-fields__container" data-testid="split-fields">
                <div className="split-fields form__group-inputs form__input" style={style}>
                    {placeholder && <label>{placeholder}</label>}
                    <div className={coverClass} onClick={this.handleClick}>
                        <div className={formInputClass}>
                            <div className={classCol}>
                                <input
                                    onFocus={this.handleOnFocus}
                                    onBlur={this.handleOnBlur}
                                    onKeyPress={this.handleKeyPress}
                                    readOnly
                                    type="text"
                                    value={text}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={showChildrenClass}>{this.props.children}</div>
                </div>
            </div>
        );
    }
}

SplitFields.propTypes = {
    classCol: PropTypes.string,
    inputFocus: PropTypes.string,
    isValid: PropTypes.bool,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    text: PropTypes.string,
};

SplitFields.defaultProps = {
    classCol: '',
    inputFocus: '',
    isValid: true,
    placeholder: '',
    style: {},
    text: '',
};
module.exports = enhanceWithClickOutside(SplitFields);
